import { Presentation, FileText } from 'lucide-react';
import { Label } from '../ui/label';

export const TypePicker = ({ types, value, onPick }) => (
  <div className="space-y-2">
    <Label>Deliverable</Label>
    <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
      {types.map((t) => (
        <button
          key={t.key}
          type="button"
          onClick={() => onPick(t)}
          className={`text-left p-3 rounded-md border transition-colors ${
            value === t.key ? 'border-brand bg-brand/5 ring-2 ring-brand/20' : 'border-border-subtle hover:border-brand/40'
          }`}
          data-testid={`deck-type-${t.key}`}
        >
          <p className="font-semibold text-sm text-text-primary">{t.label}</p>
          <p className="text-xs text-text-muted mt-1 line-clamp-2">{t.description}</p>
        </button>
      ))}
    </div>
  </div>
);

const FORMATS = [
  { key: 'pptx', label: 'PowerPoint deck', icon: Presentation },
  { key: 'docx', label: 'Word document', icon: FileText },
];

export const FormatToggle = ({ value, onChange }) => (
  <div className="space-y-2">
    <Label>Output</Label>
    <div className="flex gap-2">
      {FORMATS.map(({ key, label, icon: Icon }) => (
        <button
          key={key}
          type="button"
          onClick={() => onChange(key)}
          className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border text-sm font-medium transition-colors ${
            value === key ? 'border-brand bg-brand text-white' : 'border-border-subtle text-text-secondary hover:border-brand/40'
          }`}
          data-testid={`deck-format-toggle-${key}`}
        >
          <Icon size={14} /> {label}
        </button>
      ))}
    </div>
  </div>
);

export const NativeSelect = ({ id, label, value, onChange, options, placeholder }) => (
  <div className="space-y-2">
    <Label htmlFor={id}>{label}</Label>
    <select
      id={id}
      value={value}
      onChange={onChange}
      className="w-full h-10 rounded-md border border-input bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-brand/30"
      data-testid={id}
    >
      <option value="">{placeholder}</option>
      {options.map((o) => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </select>
  </div>
);
